/**
 * Stores build information about <b>this specific version of the `ruffle-core` library</b>.
 *
 * It does not represent the version of Ruffle that may be in use by the page (for example, if a browser extension overrides it).
 *
 * @privateRemarks
 * This is generated at build time via `set_version.ts`.
 */
export const buildInfo = {
    versionNumber: "0.1.0",
    versionName: "0.1.0 nightly 2025-05-13",
    versionChannel: "nightly",
    buildDate: "2025-05-13T00:06:59.307Z",
    commitHash: "34b1176b61ead65196de52ef3e2de643d47c1a9c",
};
